/* ================================================================
   Antoinette & Louis - message de franco et codes de livraison

   Un code de reduction de type "expedition" (livraison offerte) n'est
   jamais visible dans l'objet cart de Liquid : Shopify ne l'applique
   qu'a l'etape paiement, une fois l'adresse saisie. Sans ce correctif,
   une cliente qui arrive depuis un e-mail avec un code livraison offerte
   lit "Plus que X pour beneficier de la livraison offerte", soit
   exactement l'inverse de ce que l'e-mail vient de lui promettre.

   On lit donc /cart.js cote client. Si un code applicable ne reduit pas
   le panier (total_discount a 0), c'est une remise d'expedition : on
   remplace le message de franco au lieu de le contredire.
   ================================================================ */
(function () {
  'use strict';

  var BLOCK = '[data-al-free-shipping]';
  var DONE = 'data-al-code-applied';
  var timer = null;

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function paint(cart) {
    var codes = (cart.discount_codes || []).filter(function (entry) {
      return entry && entry.applicable;
    });

    // Un code qui ne fait baisser ni le sous-total ni une ligne produit
    // ne peut etre qu'une remise d'expedition.
    if (!codes.length || cart.total_discount !== 0) return;

    Array.prototype.forEach.call(document.querySelectorAll(BLOCK), function (block) {
      if (block.hasAttribute(DONE)) return;

      var text = block.querySelector('.free-shipping__text');
      if (!text || text.classList.contains('free-shipping__text--success')) return;

      var message = block.getAttribute('data-al-code-message');
      if (!message) return;

      text.textContent = message.replace('%CODE%', codes[0].code);
      text.classList.add('free-shipping__text--al-code');

      var bar = block.querySelector('.free-shipping__progress');
      if (bar) {
        bar.classList.add('free-shipping__progress--al-code');
        bar.style.setProperty('--progress', '100%');
      }

      block.setAttribute(DONE, '');
    });
  }

  function refresh() {
    if (!document.querySelector(BLOCK)) return;

    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) paint(cart);
      })
      .catch(function () {
        /* Panier injoignable : on laisse le message d'origine du theme. */
      });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Le theme re-rend la section panier a chaque changement de quantite :
  // le bloc franco revient alors dans son etat d'origine, il faut repasser.
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (document.querySelector(BLOCK + ':not([' + DONE + '])')) schedule();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* ================================================================
   Antoinette & Louis - barre d'achat collante (mobile)

   Markup : snippets/al-sticky-cta.liquid. Styles : al-custom.css.
   La barre se montre une fois le premier bloc de la page (le hero)
   sorti de l'ecran, et se cache des que le pied de page arrive, pour
   ne pas recouvrir l'inscription newsletter ni les liens du footer.
   ================================================================ */
(function () {
  'use strict';

  var bar = document.querySelector('[data-al-sticky-cta]');
  if (!bar || !window.IntersectionObserver) return;

  var link = bar.querySelector('a');
  var hero = document.querySelector('#MainContent > .shopify-section');
  var footer = document.querySelector('.shopify-section-group-footer-group, footer');
  var heroGone = false;
  var footerIn = false;

  function render() {
    var show = heroGone && !footerIn;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (link) link.tabIndex = show ? 0 : -1;
    document.body.classList.toggle('al-sticky-cta-on', show);
  }

  if (hero) {
    new IntersectionObserver(function (entries) {
      // Le hero ne compte comme "parti" que s'il est passe AU-DESSUS de l'ecran.
      heroGone = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      render();
    }).observe(hero);
  }

  if (footer) {
    new IntersectionObserver(function (entries) {
      footerIn = entries[0].isIntersecting;
      render();
    }).observe(footer);
  }
})();


/* ================================================================
   Fiche album : barre fixe mobile (snippets/al-fiche-sticky.liquid)
   Visible quand le bouton principal est passe AU-DESSUS de l'ecran (le visiteur continue a descendre),
   masquee quand il redevient visible. L'ouverture de l'assistant la masque par CSS (body.alq-locked).
   ================================================================ */
(function () {
  'use strict';

  var bar = document.querySelector('[data-al-fiche-sticky]');
  var main = document.querySelector('.al-fiche > .al-assistant-cta');
  if (!bar || !main || !window.IntersectionObserver) return;

  var link = bar.querySelector('a');

  new IntersectionObserver(function (entries) {
    var e = entries[0];
    var show = !e.isIntersecting && e.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (link) link.tabIndex = show ? 0 : -1;
    document.body.classList.toggle('al-fiche-sticky-on', show);
  }).observe(main);
})();

/* Avis Judge.me (widget jm-*, rendu par l'app) : trois retouches que le CSS ne peut pas faire.
   1. miniatures : l'app sert du 160 px, trop flou dans les cartes agrandies -> width=640
   2. cartes sans photo : l'app coupe l'avis à 5 lignes par un style inline -> 12 lignes
   3. flèches précédent / suivant sur la ligne d'avis (desktop ; style dans al-custom.css)
   Le widget se redessine souvent : un seul observateur, chaque retouche est idempotente. */
(function () {
  var LIST = '.jdgm-review-widget .jdgm-review-list';
  var THUMB = '.jm-media-thumbnail-list__thumbnail';
  var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function sharpenPhotos(list) {
    list.querySelectorAll(THUMB + ' img').forEach(function (img) {
      ['src', 'srcset'].forEach(function (attr) {
        var v = img.getAttribute(attr);
        if (v && /[?&]width=(160|480)\b/.test(v)) {
          img.setAttribute(attr, v.replace(/([?&]width=)(160|480)\b/g, '$1640'));
        }
      });
    });
  }

  function relaxTextOnlyCards(list) {
    Array.prototype.forEach.call(list.children, function (card) {
      if (card.querySelector(THUMB)) return;
      var body = card.querySelector('.jm-review-content__body');
      if (body && body.style.webkitLineClamp === '5') body.style.webkitLineClamp = '12';
    });
  }

  function addArrow(host, dir, label) {
    var b = host.querySelector('.al-avis-nav--' + dir);
    if (b) return b;
    b = document.createElement('button');
    b.type = 'button';
    b.className = 'al-avis-nav al-avis-nav--' + dir;
    b.setAttribute('aria-label', label);
    b.innerHTML = CHEVRON;
    if (dir === 'prev') b.firstChild.style.transform = 'scaleX(-1)';
    host.appendChild(b);
    return b;
  }

  function addArrows(list) {
    var host = list.closest('.jm-review-widget__body');
    if (!host) return;
    var prev = addArrow(host, 'prev', 'Avis précédents');
    var next = addArrow(host, 'next', 'Avis suivants');

    function update() {
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
    }
    function go(sign) {
      var card = list.firstElementChild;
      list.scrollBy({ left: sign * (card ? card.getBoundingClientRect().width + 20 : list.clientWidth), behavior: 'smooth' });
    }
    prev.onclick = function () { go(-1); };
    next.onclick = function () { go(1); };
    if (!list.dataset.alNav) {
      list.dataset.alNav = '1';
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
    update();
  }

  function run() {
    var list = document.querySelector(LIST);
    if (!list) return;
    sharpenPhotos(list);
    relaxTextOnlyCards(list);
    addArrows(list);
  }

  if (!window.MutationObserver) return;
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 100);
  }).observe(document.body, { childList: true, subtree: true });
  run();
})();
